// extracted by mini-css-extract-plugin
module.exports = {"subtitleItem":"DropdownSubtitleItem__subtitleItem___1iCqX","title":"DropdownSubtitleItem__title___2UMuM","subtitle":"DropdownSubtitleItem__subtitle___FOHRH"};